export const lockBody = () => document.body.classList.add('body--locked');
export const unlockBody = () => document.body.classList.remove('body--locked');
export const toggleBodyLock = () => document.body.classList.contains('body--locked') ? unlockBody() : lockBody();
